import getStore from '../store/store';
import { NoteColor } from '@notes/sticky-notes-sdk';
import { mutatorAction } from 'satcheljs';

export const setSelectedNoteColor = mutatorAction(
    'setSelectedNoteColor',
    (selectedNoteColor: NoteColor | undefined) => {
        getStore().selectedNoteColor = selectedNoteColor;
    }
);
